import { render, staticRenderFns } from "./Textblock.vue?vue&type=template&id=9734d94c&"
import script from "./Textblock.vue?vue&type=script&lang=js&"
export * from "./Textblock.vue?vue&type=script&lang=js&"
import style0 from "./Textblock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports